import { useSchemaIntrospection } from "src/queries/hooks/knowledgeExplore";
import { ID_FIELD_SUFFIX, ENTITY_LABEL_FIELD_NAMES } from "../ExploreTab.consts";

export const findPkField = (fields, pkFieldName) => {
  if (pkFieldName) return (fields ?? []).find((f) => f.name === pkFieldName) ?? null;
  return (fields ?? []).find((f) => f.name.toLowerCase().endsWith(ID_FIELD_SUFFIX)) ?? null;
};
export const findLabelField = (fields, labelFieldName) => {
  if (labelFieldName) return (fields ?? []).find((f) => f.name === labelFieldName) ?? null;
  return ENTITY_LABEL_FIELD_NAMES.map((name) => (fields ?? []).find((f) => f.name === name)).find(Boolean) ?? null;
};

export const resolveLabelText = (value, defaultLanguage) => {
  if (value === null || typeof value !== "object") return value;
  const keys = Object.keys(value);
  if (keys.length === 0) return null;
  const preferredKey = defaultLanguage && keys.includes(defaultLanguage) ? defaultLanguage : keys[0];
  if (value[preferredKey]) return value[preferredKey];
  const fallbackKey = keys.find((key) => value[key]);
  return fallbackKey ? value[fallbackKey] : null;
};

export const toOption = (item, pkField, labelField, defaultLanguage) => {
  const id = pkField ? item[pkField.name] : null;
  const rawLabel = labelField ? item[labelField.name] : null;
  const label = resolveLabelText(rawLabel, defaultLanguage);
  return { key: id, display_key: label ?? String(id), description: label ? String(id) : null };
};

// The referenced entity is read at the caller's version — the one the row being shown or
// edited lives in. Entity refs only ever point within their own knowledge group, and a build
// or a draft writes the whole group at one version, so that version always exists for the
// target schema; the newest listed partition may be an orphan (a discarded draft's build).
export const useEntityRefFields = ({ entityType, pkFieldName, labelFieldName, version }) => {
  const introspection = useSchemaIntrospection(entityType);
  const entityFields = introspection.data?.__type?.fields ?? [];
  const pkField = findPkField(entityFields, pkFieldName);
  const labelField = findLabelField(entityFields, labelFieldName);
  const selectedFields = [pkField, labelField].filter(Boolean);

  return {
    entityVersion: version ?? null,
    pkField,
    labelField,
    selectedFields,
    isLoading: introspection.isLoading
  };
};
